import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[fcnavtabcontent]',
})
export class FcnavtabcontentDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}

